import styles from "src/components/molecules/InfoMessage/styles.module.css";
import Info from "src/assets/icons/infoClock.svg";
import { Msg } from "src/i18n/Msg";

export const InfoMessage = () => (
  <div className={styles.messageWrapper}>
    <img src={Info} alt="Info" />
    <h3>
      <Msg id="components.molecules.InfoMessage.title" />
    </h3>
    <p>
      <Msg id="components.molecules.InfoMessage.description" />
    </p>
  </div>
);
